import {
  ActivityContextDto,
  ActivityFeedEntityLinkDto,
  EntityTypeEnum
} from 'api/activity-feed';

/**
 * Destination « dossier » d'un contexte : espace emprunteur si projet d'emprunt,
 * sinon page contrat si contrat, sinon le dossier de simulation (route résolveur).
 */
export const dossierUrlFromContext = (context: ActivityContextDto): string => {
  if (context.borrowerProjectId) {
    return `/simulation/dossier-emprunteur/${context.borrowerProjectId}/${context.riskId}`;
  }
  if (context.contractId) {
    return `/mes-contrats/details/${context.contractId}`;
  }
  return `/simulation/dossier/${context.riskId}`;
};

export interface ActivityRowLike {
  riskId?: string | null;
  category?: string | null;
  context?: ActivityContextDto | null;
  entities?: ActivityFeedEntityLinkDto[];
}

/**
 * Règle de clic sur une ligne du flux / des notifications, par priorité :
 *   1. riskId présent -> dossier (routes contrat/emprunteur via context) ;
 *   2. sinon entité Note -> détail de la note (entrées hors dossier : note client, note libre) ;
 *   3. sinon entité Personne -> fiche client ;
 *   4. sinon pas de navigation.
 */
export const getActivityRowUrl = (item: ActivityRowLike): string | null => {
  if (item.riskId) {
    return item.context
      ? dossierUrlFromContext(item.context)
      : `/simulation/dossier/${item.riskId}`;
  }

  const note = item.entities?.find((e) => e.entityType === EntityTypeEnum.Note);
  if (note) return `/mes-notes?noteId=${note.entityId}`;

  const person = item.entities?.find(
    (e) => e.entityType === EntityTypeEnum.Personne
  );
  if (person) return `/mes-clients/${person.entityId}`;

  return null;
};
